import SubscriptionCard from '@/components/settings/SubscriptionCard';
import { RxCardStack } from 'react-icons/rx';
import { TabsContent } from '@/components/elements/Tabs';
import NoResults from '@/components/elements/NoResults';
import TitleSubtitle from '@/components/elements/TitleSubtilte';
import SubscriptionCardSkeleton from '@/components/skeletons/SubscriptionCardSkeleton';
import type { Subscription } from '@/types/models.types';

interface SubscriptionsProps {
  subscriptions: Subscription[];
  isLoading: boolean;
}

function Subscriptions({ subscriptions, isLoading }: SubscriptionsProps) {
  return (
    <TabsContent value='subscriptions'>
      <header>
        <TitleSubtitle title='Subscriptions' subtitle='Manage your subscriptions to packages and authors.' />
      </header>

      <div className='mt-4' data-cy='subscriptions'>
        {isLoading ? (
          <SubscriptionCardSkeleton />
        ) : subscriptions.length > 0 ? (
          <div data-cy='subscriptions' className='flex flex-col gap-4'>
            {subscriptions.map((subscription) => (
              <SubscriptionCard key={subscription.id} subscription={subscription} />
            ))}
          </div>
        ) : (
          <NoResults
            icon={<RxCardStack />}
            title='No active subscriptions'
            description="You haven't subscribed to a package or author yet."
          />
        )}
      </div>
    </TabsContent>
  );
}

export default Subscriptions;
